import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicInputComponent } from './components/basic-input/basic-input.component';
import { BasicButtonComponent } from './components/basic-button/basic-button.component';
import { BasicSimpleButtonComponent} from "./components/basic-simple-button/basic-simple-button.component";
import { HeaderComponent } from './components/header/header.component';

@NgModule({
  declarations: [
    BasicInputComponent,
    BasicButtonComponent,
    BasicSimpleButtonComponent,
    HeaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BasicInputComponent,
    BasicButtonComponent,
    BasicSimpleButtonComponent,
    HeaderComponent
  ],
})
export class ThemeModule { }
